import createStoreWithMiddleware from "./ConfigureStore";

export const { store, persistor, middlewares } = createStoreWithMiddleware();
